<template>
  <o-dialog
    ref="dialog"
    :title="$t('updatePrices.title')"
    :info="$t('components.employee.actions.updatePrices.info')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel', callback: cancel },
      { text: $t('general.confirm'), type: 'confirm', callback: confirm }
    ]"
    :loading="loading"
    @close="handleDialogClose"
  >
    <div class="-mx-4 border-t border-b p-4 text-left">
      <o-field-group
        :label="$t('updatePrices.updateFutureAppointments')"
        :info="$t('updatePrices.updateFutureAppointmentsInfo')"
        class="mb-3"
        col
        reverse
      >
        <toggle-field
          v-model="updateFutureReservations"
        />
      </o-field-group>
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import { OFieldGroup } from '@/components/elements'
import { ToggleField } from '@/components/fields'

import type { Employee } from '~/_api/models/employee'

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'error'): void
}

const emit = defineEmits<Emits>()
const { $api, $notification } = useNuxtApp()

const dialog = ref<any>()
const loading = ref(false)
const employee = ref<Employee | null>(null)
const updateFutureReservations = ref(false)
const resolvePromise = ref<((value: boolean) => void) | null>(null)

const dialogActive = computed(() => {
  return dialog.value ? dialog.value.active : false
})

watch(dialogActive, (newVal) => {
  console.log('dialog active status changed:', newVal)
})

const handleDialogClose = () => {
  resolvePromise.value?.(true)
}

const open = (emp: Employee) => {
  employee.value = emp

  dialog.value.open()

  return new Promise<boolean>((resolve) => {
    resolvePromise.value = resolve
  })
}

const confirm = async () => {
  if (!employee.value) return false

  emit('update:loading', true)

  try {
    if (updateFutureReservations.value) {
      const response = await $api.employee.updatePrices(employee.value, updateFutureReservations.value)
      emit('update:loading', false)

      if (response.success) {
        emit('success')
      }
    }

    resolvePromise.value?.(true)

    return true
  } catch (e: any) {
    $notification.error({ errors: e?.errors })

    emit('error')

    resolvePromise.value?.(true)

    return false
  }
}

const cancel = () => {
  resolvePromise.value?.(true)
  dialog.value.close()
}

defineExpose({ open })
</script>
